import { render } from "./BtnToggle.vue?vue&type=template&id=f018128a&scoped=true"
import script from "./BtnToggle.vue?vue&type=script&lang=js"
export * from "./BtnToggle.vue?vue&type=script&lang=js"

import "./BtnToggle.vue?vue&type=style&index=0&id=f018128a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f018128a"]])

export default __exports__